import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = {
  id: "",
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_6 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_7 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_8 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_25 = {
  key: 0,
  class: "badge bg-warning text-dark"
}
const _hoisted_26 = {
  key: 1,
  class: "badge bg-success"
}
const _hoisted_27 = {
  key: 2,
  class: "badge bg-danger"
}
const _hoisted_28 = {
  key: 3,
  class: "badge bg-info"
}
const _hoisted_29 = {
  key: 4,
  class: "badge bg-primary"
}
const _hoisted_30 = {
  key: 5,
  class: "badge bg-secondary"
}
const _hoisted_31 = {
  key: 6,
  class: "badge bg-secondary"
}
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 2,
  class: "text-muted fs-12"
}
const _hoisted_36 = { id: "transactionsTable" }
const _hoisted_37 = {
  class: "text-center",
  id: "title"
}
const _hoisted_38 = {
  id: "",
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_39 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_40 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_41 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_42 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_43 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_44 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_45 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_46 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_47 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_50 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_51 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_52 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_53 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_54 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_55 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_56 = {
  key: 0,
  class: "badge bg-warning text-dark"
}
const _hoisted_57 = {
  key: 1,
  class: "badge bg-success"
}
const _hoisted_58 = {
  key: 2,
  class: "badge bg-danger"
}
const _hoisted_59 = {
  key: 3,
  class: "badge bg-info"
}
const _hoisted_60 = {
  key: 4,
  class: "badge bg-primary"
}
const _hoisted_61 = {
  key: 5,
  class: "badge bg-secondary"
}
const _hoisted_62 = {
  key: 6,
  class: "badge bg-secondary"
}
const _hoisted_63 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_64 = {
  key: 0,
  class: "badge bg-warning text-dark"
}
const _hoisted_65 = {
  key: 1,
  class: "badge bg-success"
}
const _hoisted_66 = {
  key: 2,
  class: "badge bg-danger"
}
const _hoisted_67 = {
  key: 3,
  class: "badge bg-secondary"
}
const _hoisted_68 = {
  key: 4,
  class: "badge bg-secondary"
}
const _hoisted_69 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_70 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_71 = { class: "modal-dialog modal-sm modal-dialog-centered" }
const _hoisted_72 = { class: "modal-content" }
const _hoisted_73 = { class: "modal-header" }
const _hoisted_74 = { class: "modal-title fs-5" }
const _hoisted_75 = { class: "modal-body" }
const _hoisted_76 = { style: {} }
const _hoisted_77 = {
  key: 0,
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_78 = {
  key: 1,
  class: "text-success fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_79 = { key: 0 }
const _hoisted_80 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_81 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_82 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_83 = ["disabled"]
const _hoisted_84 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_85 = { style: {"color":"#FFF"} }
const _hoisted_86 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_87 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_88 = { class: "modal-content" }
const _hoisted_89 = { class: "modal-header" }
const _hoisted_90 = { class: "modal-title fs-5" }
const _hoisted_91 = { class: "modal-body" }
const _hoisted_92 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_93 = { class: "row" }
const _hoisted_94 = { class: "col-md-6" }
const _hoisted_95 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_96 = { class: "col-md-6" }
const _hoisted_97 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-md-6" }
const _hoisted_100 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_101 = { class: "col-md-6" }
const _hoisted_102 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_103 = { class: "row" }
const _hoisted_104 = { class: "col-md-6" }
const _hoisted_105 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_106 = { class: "col-md-6" }
const _hoisted_107 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_108 = { class: "row" }
const _hoisted_109 = { class: "col-md-6" }
const _hoisted_110 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_111 = { class: "col-md-6" }
const _hoisted_112 = { class: "d-block text-black fw-semibold mb-10" }

import { ref, onMounted, onBeforeMount, inject, computed } from "vue";
import { useRoute } from 'vue-router'
import axios from 'axios';
import flatpickr from "flatpickr";
import html2pdf from "html2pdf.js";
import { useI18n } from "vue-i18n";
import LeadscontentPdf from "./LeadsContentPdf.vue";
import router from '../../../router/index'
import conf from '../../../../env.json'
import { current_permissions } from '../../../utils/permission';
import { showToast, checkSessionValidate } from '../../../utils/function'
import TransactionRepository from '../../../repositories/TransactionRepository'
import { Business, Transaction } from "@/utils/Model";
declare interface Organization {
  id: string,
  code: string,
  name: string,
  description: string,
  email: string,
  created_at: string
}

declare interface Operator {
  id: string,
  code: string,
  mnoName: string,
  status: string,
  countryCode: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ValidationOneTransfertContent',
  setup(__props) {


let role: string|null = localStorage.getItem('role');
const backApi = inject('back');

let url = '';
  if (role == 'SUPERADMIN' || role == 'BUSINESS' || role == 'SUPPORT') {
    url = backApi + '/secure/transactions/extended';
  } else {
    url = backApi + '/secure/transactions';
  }

const { t } = useI18n();
let data = [];
let beginDate = ref('');
let endDate = ref('');
let today = ref('');
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedStatus = ref('');
const loader = ref(false);
const page = ref(1);
const total = ref(0);
const pagesLeft = ref(0);
const currentPage = ref(0);
const numPages = ref(0);
const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const amount = ref(0);
const operator = ref('');
const statusLabel = ref('');
const validationStatus = ref('');
const status = ref('');
const message = ref('');
const payoutIdLink = ref('');
const btnLoad = ref(true);
const errors = ref('');
const errorId = ref('');

const transactions = ref(new Array<Transaction>());
const organizations = ref(new Array<Organization>());
const operators = ref(new Array<Operator>());
let operatorsTemp = new Array<Operator>();
const transaction = ref({} as Transaction);

let transactionId: string | null;
let idType: string | null;

// Fonction de formatage de date avec gestion de null
function formatDateFr(value) {
    // Si la valeur est null, undefined ou vide, retourner "01/01/1970"
    if (!value) {
        return '01/01/1970';
    }
    
    try {
        const date = new Date(value);
        // Vérifier si la date est valide
        if (isNaN(date.getTime())) {
            return '01/01/1970';
        }
        
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        let day = date.getDate();
        day = day < 10 ? '0' + day : day;
        let hours = date.getHours();
        hours = hours < 10 ? '0' + hours : hours;
        let minutes = date.getMinutes();
        minutes = minutes < 10 ? '0' + minutes : minutes;
        
        // Format: JJ/MM/YYYY HH:MM
        return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
    } catch (error) {
        return '01/01/1970';
    }
}

// Computed property pour la date de transaction formatée dans le modal
const formattedTransactionDate = computed(() => {
    return formatDateFr(transaction.value.transactionDate);
});

// Computed property pour la date d'expiration formatée dans le modal
const formattedExpirationDate = computed(() => {
    return formatDateFr(transaction.value.publicTokenValidationExpireAt);
});

// Fonction pour obtenir le libellé du statut (status)
function getStatusLabel(statusValue) {
    const statusMap = {
        'PENDING': 'EN ATTENTE',
        'SUCCEEDED': 'SUCCÈS',
        'FAILED': 'ÉCHEC',
        'PROCESSING': 'EN COURS',
        'INITIATED': 'INITIÉ',
        'SCHEDULED': 'PLANIFIÉ'
    };
    return statusMap[statusValue] || statusValue || 'INCONNU';
}

// Fonction pour obtenir la classe CSS du statut (status)
function getStatusClass(statusValue) {
    const classMap = {
        'PENDING': 'bg-warning text-dark',
        'SUCCEEDED': 'bg-success',
        'FAILED': 'bg-danger',
        'PROCESSING': 'bg-info',
        'INITIATED': 'bg-primary',
        'SCHEDULED': 'bg-secondary'
    };
    return classMap[statusValue] || 'bg-secondary';
}

// Fonction pour obtenir le libellé du statut de validation
function getValidationStatusLabel(statusValue) {
    const statusMap = {
        'DRAFT': 'BROUILLON',
        'VALIDATED': 'VALIDÉ',
        'REJECTED': 'REJETÉ',
        'EXPIRED': 'EXPIRÉ'
    };
    return statusMap[statusValue] || 'INCONNU';
}

function formatDateEn(value, d = 0) {
    if (value) {
        const year = value.getFullYear();
        let month = value.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        let day = value.getDate() + d;
        day = day < 10 ? '0' + day : day;
        return year + '-' + month + '-' + day;
    }
    return '';
}

function formatDateEnBis(value, d = 0) {
    if (value) {
        const year = value.getFullYear();
        let month = value.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        let day = value.getDate() + d;
        day = day < 10 ? '0' + day : day;
        return year + '-' + month + '-' + day;
    }
    return '';
}

const cancel = () => {
    status.value = "";
    errorId.value = "";
    errors.value = "";
    payoutIdLink.value = "";
}

function handleOrganizationChange(event) {
    selectedOrganization.value = event.target.value;
}

function handleOperatorChange(event) {
    selectedOperator.value = event.target.value;
}

function handleStatusChange(event) {
    selectedStatus.value = event.target.value;
}

function handleCountryChange(event) {
    var j = 0;
    var operatorArr = new Array<Operator>();
    while (j < operatorsTemp.length) {
        if (operatorsTemp[j].countryCode == event.target.value) {
            operatorArr.push(operatorsTemp[j]);
        }
        j++;
    }
    operators.value = operatorArr;
}

let datab = '';

onMounted(() => {
    checkSessionValidate(1)
    const route = useRoute();
    transactionId = route.params.transactionId;
    idType = route.params.idType;
    getTransactions();
    setTimeout(function () {
        flatpickr("#lead-calendar", {
            altInput: true,
            altFormat: "F j, Y",
            dateFormat: "Y-m-d",
            defaultDate: "today",
            enableTime: true,
        });
    }, 1000);

    flatpickr("#basic-calendar", {
        dateFormat: "Y-m-d H:i",
    });
});

const token = localStorage.getItem('login_token');

const loadTransaction = (code) => {
    axios.get(`${url}/${code}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
        .then((response) => {
            transaction.value = response.data;
            operator.value = response.data.operator?.mnoName;
            amount.value = response.data.amount.toLocaleString();
            
            // Récupérer le statut (status)
            statusLabel.value = getStatusLabel(response.data.status);
            
            // Récupérer le statut de validation
            validationStatus.value = getValidationStatusLabel(response.data.publicTokenValidationStatus);

            loader.value = true;
        }).catch((error) => {
            loader.value = true;
            if (error.response) {
                console.log(error.response.data);
                if (error.response.status === 401) {
                    router.push('/');
                }
            }
        });
}

const getTransactions = (arg = 1) => {
    loader.value = false;
    gettran.value = true;
    search.value = false;
    search1.value = false;

    axios.get(`${url}?page=${arg}&publicTokenValidationStatus=DRAFT`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
        .then((response) => {
            transactions.value = response.data.data;
            total.value = parseInt(response.data.pagination.total);
            page.value = parseInt(response.data.pagination.currentPage);
            currentPage.value = parseInt(response.data.pagination.currentPage);
            numPages.value = parseInt(response.data.pagination.numPages);
            loader.value = true;
        }).catch((error) => {
            loader.value = true;
            if (error.response) {
                console.log(error.response.data);
                if (error.response.status === 401) {
                    router.push('/');
                }
            }
        });
}

const getOrganizations = () => {
    axios.get(backApi + '/secure/organizations/', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
        .then((response) => {
            organizations.value = response.data;
            console.log(response.data);
        }).catch((error) => {
            if (error.response) {
                console.log(error.response.data);
                if (error.response.status === 401) {
                    router.push('/')
                }
            }
        });
}

const getOperators = () => {
    axios.get(backApi + '/public/operators/', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
        .then((response) => {
            operatorsTemp = response.data;
            console.log(response.data);
        }).catch((error) => {
            if (error.response) {
                console.log(error.response.data);
                if (error.response.status === 401) {
                    router.push('/')
                }
            }
        });
}

const exportExcelReport = (labels, fields, filename) => {
    import("../../../utils/Export2Excel").then((excel) => {
        const dataForExcel = formatJSon(fields, data);
        excel.export_json_to_excel({
            header: labels,
            data: dataForExcel,
            sheetName: "Feuil1",
            filename: filename,
            autoWidth: true,
            bookType: "xlsx",
        });
    });
}

const exportExcel = () => {
    import("../../../utils/Export2Excel").then((excel) => {
        const Header = ["CODE TRANSACTION", "OPERATEUR", "TELEPHONE", "MONTANT", "DATE", "DATE EXPIRATION", "STATUT", "STATUT VALIDATION"];
        const Fields = ["payoutId", "operator_name", "contact", "amount", "transactionDate", "publicTokenValidationExpireAt", "status", "publicTokenValidationStatus"];
        const dataForExcel = formatJSon(Fields, data);
        excel.export_json_to_excel({
            header: Header,
            data: dataForExcel,
            sheetName: "Feuil1",
            filename: "transactions",
            autoWidth: true,
            bookType: "xlsx",
        });
    });
}

function formatJSon(FilterData, JsonData) {
    return JsonData.map((v) => FilterData.map(j => {
        return v[j];
    }));
}

const searchTransaction = (arg = 1) => {
    loader.value = false;
    gettran.value = false;
    search.value = true;
    search1.value = false;

    if (beginDate.value === '') {
        beginDate.value = formatDateEn(new Date());
    }

    if (endDate.value === '') {
        endDate.value = formatDateEn(new Date(), 1);
    }
    const todayE = formatDateEn(new Date(endDate.value), 1);
    axios.get(`${url}?page=${arg}&dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operator=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
        .then((response) => {
            transactions.value = response.data.data;
            total.value = parseInt(response.data.pagination.total);
            page.value = parseInt(response.data.pagination.currentPage);
            currentPage.value = parseInt(response.data.pagination.currentPage);
            numPages.value = parseInt(response.data.pagination.numPages);
            loader.value = true;
        }).catch((error) => {
            loader.value = true;
            if (error.response) {
                console.log(error.response.data);
                if (error.response.status === 401) {
                    router.push('/');
                }
            }
        });
}

const searchTransaction1 = (event, arg = 1) => {
    if (typeof event.target.value !== 'undefined') {
        today.value = event.target.value
    }

    loader.value = false;
    gettran.value = false;
    search.value = false;
    search1.value = true;

    const todayE = formatDateEn(new Date(today.value), 1);
    axios.get(`${url}?page=${arg}&dateD=${today.value}&dateF=${todayE}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
        .then((response) => {
            transactions.value = response.data.data;
            total.value = parseInt(response.data.pagination.total);
            page.value = parseInt(response.data.pagination.currentPage);
            currentPage.value = parseInt(response.data.pagination.currentPage);
            numPages.value = parseInt(response.data.pagination.numPages);
            loader.value = true;
        }).catch((error) => {
            loader.value = true;
            if (error.response) {
                console.log(error.response.data);
                if (error.response.status === 401) {
                    router.push('/');
                }
            }
        });
}

const searchTransactionForExport = () => {
    btnLoad.value = false;

    if (beginDate.value === '') {
        beginDate.value = formatDateEn(new Date());
    }

    if (endDate.value === '') {
        endDate.value = formatDateEn(new Date(), 1);
    }
    const todayE = formatDateEn(new Date(endDate.value), 1);
    axios.get(`${backApi}/secure/transactions/list/export?dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operator=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
        .then((response) => {
            if (response.status === 200) {
                data = response.data;
                for (let pas = 0; pas < data.length; pas++) {
                    data[pas].operator_name = data[pas].operator?.mnoName;
                }
                exportExcel()
                btnLoad.value = true;
            }
        }).catch((error) => {
            btnLoad.value = true;
            if (error.response) {
                console.log(error.response.data);
                if (error.response.status === 401) {
                    router.push('/');
                } else {
                    errorId.value = error.response.data.errorId;
                    errors.value = error.response.data.message;
                }
            }
        });
}

const reportForExport = () => {
    btnLoad.value = false;

    if (beginDate.value === '') {
        beginDate.value = formatDateEn(new Date());
    }

    if (endDate.value === '') {
        endDate.value = formatDateEn(new Date(), 1);
    }
    const todayE = formatDateEn(new Date(endDate.value), 1);
    axios.post(`${backApi}/secure/organizations/report`,
        {
            start: beginDate.value,
            end: todayE,
            organization: selectedOrganization.value
        },
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then((response) => {
            if (response.status === 200) {
                data = response.data.transactions;
                console.log(data)

                for (let pas = 0; pas < data.length; pas++) {
                    data[pas].operationType = (data[pas].operationType == "1") ? "Payin" : "Payout";
                    data[pas].balance = parseFloat(data[pas].collectBalance - (data[pas].payoutBalance - data[pas].topupBalance));
                }

                const Header = ["CODE TRANSACTION", "DATE OPERATION", "OPERATEUR", "MONTANT", "TYPE OPERATION", "BALANCE", "STATUT"];
                const Fields = ["payoutId", "transactionDate", "status", "amount", "operationType", "", "paymentStatus"];

                exportExcelReport(Header, Fields, "report");
                btnLoad.value = true;
            }
        }).catch((error) => {
            btnLoad.value = true;
            if (error.response) {
                console.log(error.response.data);
                if (error.response.status === 401) {
                    router.push('/');
                } else {
                    errorId.value = error.response.data.errorId;
                    errors.value = error.response.data.message;
                }
            }
        });
}

const showScreen = (statut, msg, payoutId) => {
    status.value = statut;
    message.value = msg;
    payoutIdLink.value = payoutId;
}

const storeValidationLink = () => {
    try {
        btnLoad.value = false;
        axios.post(`${backApi}/secure/transactions/token/validate`, {
            publicToken: payoutIdLink.value,
            status: status.value
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        }).then((response) => {
            if (response.status === 201) {
                document.getElementById("close").click();
                showToast("Lien validé avec succès", "green");
                status.value = '';
                payoutIdLink.value = '';
                btnLoad.value = true;
                setTimeout(() => {
                    router.go();
                }, 3000);
            }
        }).catch((error) => {
            btnLoad.value = true;
            if (error.response) {
                if (error.response.status === 401) {
                    router.push('/')
                } else {
                    errorId.value = error.response.data.errorId;
                    errors.value = error.response.data.message;
                }
            }
        });
    } catch (error) {
        console.error(error);
        btnLoad.value = true;
        errors.value = "une erreur inattendue est apparue"
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, [
            _createElementVNode("div", { class: "d-sm-flex align-items-center" }),
            _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", { class: "select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0" })
              ])
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('linkValidation.code')), 1),
                    _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('linkValidation.beneficiary')), 1),
                    _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('linkValidation.operator')), 1),
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('linkValidation.phone')), 1),
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('linkValidation.amount')), 1),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('linkValidation.date')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('linkValidation.expirationDate')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('linkValidation.status')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('linkValidation.actions')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (transaction) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: transaction.payoutId
                    }, [
                      _createElementVNode("th", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(transaction.payoutId), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(transaction?.clientId), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(transaction.operator?.mnoName), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(transaction?.contact), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(transaction.amount.toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(formatDateFr(transaction.transactionDate)), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(formatDateFr(transaction.publicTokenValidationExpireAt)), 1),
                      _createElementVNode("td", _hoisted_24, [
                        (transaction.status === 'PENDING')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('linkValidation.pending')), 1))
                          : _createCommentVNode("", true),
                        (transaction.status === 'SUCCEEDED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('linkValidation.success')), 1))
                          : _createCommentVNode("", true),
                        (transaction.status === 'FAILED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('linkValidation.failed')), 1))
                          : _createCommentVNode("", true),
                        (transaction.status === 'PROCESSING')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('linkValidation.processing')), 1))
                          : _createCommentVNode("", true),
                        (transaction.status === 'INITIATED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('linkValidation.initiated')), 1))
                          : _createCommentVNode("", true),
                        (transaction.status === 'SCHEDULED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t('linkValidation.scheduled')), 1))
                          : _createCommentVNode("", true),
                        (!transaction.status)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('linkValidation.unknown')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_32, [
                        (_unref(current_permissions)('validate_public_token') && transaction.publicTokenValidationStatus === 'DRAFT')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                              type: "button",
                              style: {"background-color":"#EB9355"},
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#filterLeadModal",
                              onClick: ($event: any) => (showScreen('REJECTED','Voulez-vous vraiment annuler ce lien ?',transaction?.publicToken))
                            }, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("i", { class: "flaticon-close-1 position-relative ms-5 top-2 fs-15" }, null, -1)
                            ]))], 8, _hoisted_33))
                          : _createCommentVNode("", true),
                        _cache[14] || (_cache[14] = _createTextVNode("       ", -1)),
                        (_unref(current_permissions)('validate_public_token') && transaction.publicTokenValidationStatus === 'DRAFT')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "default-outline-btn position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                              type: "button",
                              style: {"background-color":"#EB9355"},
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#filterLeadModal",
                              onClick: ($event: any) => (showScreen('VALIDATED','Voulez-vous vraiment valider ce lien ?',transaction?.publicToken))
                            }, [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("i", { class: "flaticon-draw-check-mark position-relative ms-5 top-2 fs-15" }, null, -1)
                            ]))], 8, _hoisted_34))
                          : _createCommentVNode("", true),
                        (transaction.publicTokenValidationStatus !== 'DRAFT')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('linkValidation.noAction')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("h2", _hoisted_37, _toDisplayString(_ctx.$t('linkValidation.listTitle')), 1),
                _createElementVNode("table", _hoisted_38, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.$t('linkValidation.code')), 1),
                      _createElementVNode("th", _hoisted_40, _toDisplayString(_ctx.$t('linkValidation.operator')), 1),
                      _createElementVNode("th", _hoisted_41, _toDisplayString(_ctx.$t('linkValidation.phone')), 1),
                      _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.$t('linkValidation.amount')), 1),
                      _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.$t('linkValidation.date')), 1),
                      _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.$t('linkValidation.expirationDate')), 1),
                      _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.$t('linkValidation.status')), 1),
                      _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.$t('linkValidation.validationStatus')), 1),
                      _cache[15] || (_cache[15] = _createElementVNode("th", {
                        scope: "col",
                        class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                      }, null, -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (transaction) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: transaction.payoutId
                      }, [
                        _createElementVNode("th", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, _toDisplayString(transaction.payoutId), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_50, _toDisplayString(transaction.operator?.mnoName), 1),
                        _createElementVNode("td", _hoisted_51, _toDisplayString(transaction?.contact), 1),
                        _createElementVNode("td", _hoisted_52, _toDisplayString(transaction.amount.toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_53, _toDisplayString(formatDateFr(transaction.transactionDate)), 1),
                        _createElementVNode("td", _hoisted_54, _toDisplayString(formatDateFr(transaction.publicTokenValidationExpireAt)), 1),
                        _createElementVNode("td", _hoisted_55, [
                          (transaction.status === 'PENDING')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.$t('linkValidation.pending')), 1))
                            : _createCommentVNode("", true),
                          (transaction.status === 'SUCCEEDED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.$t('linkValidation.success')), 1))
                            : _createCommentVNode("", true),
                          (transaction.status === 'FAILED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.$t('linkValidation.failed')), 1))
                            : _createCommentVNode("", true),
                          (transaction.status === 'PROCESSING')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.$t('linkValidation.processing')), 1))
                            : _createCommentVNode("", true),
                          (transaction.status === 'INITIATED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.$t('linkValidation.initiated')), 1))
                            : _createCommentVNode("", true),
                          (transaction.status === 'SCHEDULED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$t('linkValidation.scheduled')), 1))
                            : _createCommentVNode("", true),
                          (!transaction.status)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.$t('linkValidation.unknown')), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_63, [
                          (transaction.publicTokenValidationStatus === 'DRAFT')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.$t('linkValidation.draft')), 1))
                            : _createCommentVNode("", true),
                          (transaction.publicTokenValidationStatus === 'VALIDATED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_ctx.$t('linkValidation.validated')), 1))
                            : _createCommentVNode("", true),
                          (transaction.publicTokenValidationStatus === 'REJECTED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.$t('linkValidation.rejected')), 1))
                            : _createCommentVNode("", true),
                          (transaction.publicTokenValidationStatus === 'EXPIRED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.$t('linkValidation.expired')), 1))
                            : _createCommentVNode("", true),
                          (!transaction.publicTokenValidationStatus)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.$t('linkValidation.unknown')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            (total.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_70, [
      _createElementVNode("div", _hoisted_71, [
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("h1", _hoisted_74, _toDisplayString(_ctx.$t('linkValidation.alert')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              id: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (cancel()))
            })
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              (status.value=='REJECTED' && errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_77, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true),
              (status.value=='VALIDATED' && errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_78, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true)
            ]),
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                  _createElementVNode("h6", _hoisted_80, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_81, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_unref(current_permissions)('validate_public_token'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn default-outline-btn bg-transparent",
                  style: {"background-color":"#FFF"},
                  "data-bs-dismiss": "modal",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (cancel()))
                }, _toDisplayString(_ctx.$t('linkValidation.no')), 1),
                _createElementVNode("button", {
                  disabled: !btnLoad.value,
                  type: "button",
                  class: "btn",
                  style: {"background-color":"#EB9355"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (storeValidationLink()))
                }, [
                  (!btnLoad.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_84))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.$t('linkValidation.yes')), 1)
                ], 8, _hoisted_83)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_86, [
      _createElementVNode("div", _hoisted_87, [
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("h1", _hoisted_90, _toDisplayString(_ctx.$t('linkValidation.transactionDetails')), 1),
              _cache[17] || (_cache[17] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("div", _hoisted_93, [
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t('linkValidation.transactionCode')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((transaction.value.payoutId) = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, transaction.value.payoutId]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.$t('linkValidation.phone')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((transaction.value.contact) = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, transaction.value.contact]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t('linkValidation.amount')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((amount).value = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, amount.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.$t('linkValidation.date')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formattedTransactionDate).value = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, formattedTransactionDate.value]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t('linkValidation.expirationDate')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formattedExpirationDate).value = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, formattedExpirationDate.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_106, [
                    _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.$t('linkValidation.status')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((statusLabel).value = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, statusLabel.value]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.$t('linkValidation.operator')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((operator).value = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, operator.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.$t('linkValidation.validationStatus')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((validationStatus).value = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, validationStatus.value]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _cache[18] || (_cache[18] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})